module.exports = __webpack_public_path__ + "img/madame-foresti.56a90587.jpg";